var defaultStyles = {
  "root": "Base-BackToTop",
  "button": "Base-BackToTop--Button",
  "with_lebel": "Base-BackToTop--WithLebel",
  "icon": "Base-BackToTop--Icon",
  "visible": "Base-BackToTop--Visible"
};

export { defaultStyles as default };
